import { PackagingCategory, PackagingTabKey } from '../models/Packaging';

export interface PackagingTab {
  key: PackagingTabKey;
  labelKey: string;
  categories?: PackagingCategory[];
}

// Configuración de las pestañas de filtrado
// "Todos" filtra categories[]=customer_box&categories[]=marketing_item.
// "Cajas" filtra categories[]=customer_box, "Marketing" filtra categories[]=marketing_item.
export const packagingTabs: PackagingTab[] = [
  { key: 'all', labelKey: 'tabs.all' },
  { key: 'boxes', labelKey: 'tabs.boxes', categories: ['customer_box'] },
  { key: 'marketing', labelKey: 'tabs.marketing', categories: ['marketing_item'] },
];
